module.exports = __webpack_public_path__ + "static/logo_carrefour-b545c8e68d48f668722c8e0996256f31.png";